import PropTypes from "prop-types";
import React from "react";
import { Button, Modal } from "react-bootstrap";

import Notification from "../notification/index.js";

class DeleteModal extends React.Component {
  static get displayName() {
    return "DeleteModal";
  }

  static get propTypes() {
    return {
      objectType: PropTypes.string.isRequired,
      onDelete: PropTypes.func.isRequired,
      deleteId: PropTypes.number,
      onClose: PropTypes.func,
    };
  }

  constructor(props) {
    super(props);

    this.state = {
      deleteId: this.props.deleteId,
      errorMessage: "",
    };

    this._onHide = this._onHide.bind(this);
    this._onDelete = this._onDelete.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.deleteId !== this.props.deleteId) {
      this.setState({ deleteId: this.props.deleteId });
    }
  }

  _onHide() {
    this.setState({ deleteId: undefined, errorMessage: "" }, () => {
      if (this.props.onClose) this.props.onClose();
    });
  }

  _onDelete() {
    this.props
      .onDelete()
      .then(() => {
        this.setState(
          {
            errorMessage: "",
          },
          () => {
            if (this.props.onClose) this.props.onClose();
          },
        );
      })
      .catch((e) => {
        const objectType = this.props.objectType;
        this.setState({
          errorMessage: `Failed to delete the ${objectType}. Please try again.`,
        });
      });
  }

  render() {
    return (
      <Modal show={Boolean(this.state.deleteId)} onHide={this._onHide}>
        <Modal.Header>
          <Modal.Title>Are you sure?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Notification error={this.state.errorMessage} />
          This {this.props.objectType} will be deleted permanently.
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this._onHide} variant="secondary">Close</Button>
          <Button onClick={this._onDelete} variant="danger">
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default DeleteModal;
export { DeleteModal };
